import useGoBack from 'utilities/navigation/back'
import DotsWhiteLoading from 'components/loadings/dotsWhiteLoading'
import React from 'react'
interface IFooterProps {
    isLoading: boolean
}
export default function Footer({ isLoading }: IFooterProps) {
    const goBack = useGoBack()
    return (
        <div className=" absolute bottom-0 w-full">
            <div className=" flex flex-col mx-4">
                <button
                    className=" text-center bg-green-1 text-white rounded-lg py-2.5"
                    disabled={isLoading}
                >
                    {!isLoading ? (
                        '                    ثبت درخواست'
                    ) : (
                        <DotsWhiteLoading />
                    )}
                </button>
                <button className=" my-3" onClick={goBack}>
                    بعدا
                </button>
            </div>
        </div>
    )
}
